module.exports = __webpack_public_path__ + "static/media/four.f1a4c2c4.jpg";